import Head from 'next/head';
import { Suspense, useEffect } from 'react';
import { Loader } from '../components/common';
import { Provider } from 'react-redux';
import { ErrorBoundary } from '../components/common';
import { store } from '../lib/store';
import { loadFonts } from '../utils/hooks/useFonts';
import { WhatsAppFloatingIcon } from '../components/common';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/globals.css';
import { safeRequestIdleCallback } from '../utils/helpers/utils';
import { useRouter } from 'next/router';
import { initGTM } from '../utils/services/gtmService';
import { initTrustpilot } from '../utils/services/trustpilotService';

function Hirego({ Component, pageProps }) {
    const router = useRouter()
    useEffect(() => {
        // Load all fonts progressively after page load
        const loadFontsAfterPageLoad = () => {
            try {
                // Also load the CSS file for immediate use
                loadFonts();
            } catch (error) {
                // console.error('Error loading fonts:', error);
            }
        };
        
        // Safari-safe font loading
        safeRequestIdleCallback(loadFontsAfterPageLoad, {});

        // Add error handling for unhandled promise rejections
        const handleUnhandledRejection = (event) => {
            // console.error('Unhandled promise rejection:', event.reason);
        };

        window.addEventListener('unhandledrejection', handleUnhandledRejection);

        return () => {
            window.removeEventListener('unhandledrejection', handleUnhandledRejection);
        };
    }, []);


    useEffect(() => {
      // --- Browser check ---
      if (typeof window === "undefined") return
  
      const isMobile = /Mobile|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
      const delay = isMobile ? 10000 : 8000
  
      // --- Run outside React render (similar to Angular's runOutsideAngular) ---
      const timer = setTimeout(() => {
        initGTM()
      }, delay)
  
      // --- Track route changes as "pageview" (similar to your Router subscription) ---
      const handleRouteChange = (url) => {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({ event: "pageview", page: url })
      }
  
      router.events.on("routeChangeComplete", handleRouteChange)
  
      return () => {
        clearTimeout(timer)
        router.events.off("routeChangeComplete", handleRouteChange)
      }
    }, [router.events])
  
    // Initialize Trustpilot script only if dynamic mode is enabled
    // This prevents unnecessary script loading for static mode sites
    useEffect(() => {
      if (typeof window === "undefined") return
      
      // Only initialize if dynamic mode is enabled
      const trustpilotMode = process.env.NEXT_PUBLIC_TRUSTPILOT_MODE || 'static'
      if (trustpilotMode === 'dynamic') {
        // Initialize Trustpilot after a delay to not impact initial page load
        initTrustpilot()
      }
    }, [])

    return (
        <ErrorBoundary>
            <Provider store={store}>
                <Head>
                    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
                    <meta name="google-site-verification" content={process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION} />
                    
                </Head>
                
                {/* Skip Links for Accessibility */}
                <a href="#main-content" className="skip-link">Skip to main content</a>
                <a href="#navigation" className="skip-link" style={{ top: '-88px' }}>Skip to navigation</a>
                
                <main id="main-content" role="main">
                    <Suspense fallback={<Loader type="loading" message="Loading page..." description="Please wait a moment." fullPage={true} />}>
                        <Component {...pageProps} />
                    </Suspense>
                </main>
                
                {/* Global WhatsApp Floating Icon */}
                 <WhatsAppFloatingIcon 
                    phoneNumber="+447488884496" 
                    message="Hello! I'm interested in your services. Can you help me?"
                />
            </Provider>
        </ErrorBoundary>
    );
}

export default Hirego;
